
export function setFirst(groupList){
	for(let i=0;i<groupList.length;i++){
		groupList[i].publish = {
			user_ids:[],
			user_name:[]
		}
		groupList[i].play = {
			user_ids:[],
			user_name:[]
		}
		groupList[i].material = {
			user_ids:[],
			user_name:[]
		}
		if(groupList[i].child.length!=0){
			setFirst(groupList[i].child);
		}
	}
}

export function setGroupInfo(groupList,setInfo){
	// setFirst(groupList);
	for(let i=0; i<groupList.length; i++){
		if(groupList[i].id==setInfo.group_id){
			let state = setInfo.check_state.toString(2);
			while(state.length<3){
				state = '0' + state;
			}
			let publish_state = state.substr(state.length-1,1);
			let play_state = state.substr(state.length-2,1);
			let material_state = state.substr(state.length-3,1);
			if(publish_state==1){
				groupList[i].publish.user_ids.push(setInfo.user_id);
				groupList[i].publish.user_name.push(setInfo.user_name);
			}
			if(play_state==1){
				groupList[i].play.user_ids.push(setInfo.user_id);
				groupList[i].play.user_name.push(setInfo.user_name);
			}
			if(material_state==1){
				groupList[i].material.user_ids.push(setInfo.user_id);
				groupList[i].material.user_name.push(setInfo.user_name);
			}
		}
		if(groupList[i].child.length!=0){
			setGroupInfo(groupList[i].child,setInfo);
		}
	}
	return groupList;
}